import {
  Box,
  Burger,
  Container,
  Flex,
  Group,
  Space,
  TextInput,
  UnstyledButton,
} from "@mantine/core";
import { useFocusTrap } from "@mantine/hooks";
import Link from "next/link";
import type { FC } from "react";
import { useState } from "react";
import { MdCancel, MdSearch } from "react-icons/md";
import { AvatarIconMemo } from "src/component/element";
import { NotificationBadgeCount } from "src/component/element/Notification/NotificationBadgeCount";
import { usePageTitle } from "src/hooks/usePageTitle";
import { DrawerMenuMemo } from "src/layout/AppLayout/DrawerMenu";
import { useGetUserSettingsQuery } from "src/service/UsersApi";

import styles from "./Header.module.scss";

export const Header: FC = () => {
  const { data: userData } = useGetUserSettingsQuery();
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [searchOpen, setSearchOpen] = useState<boolean>(false);

  const pageTitle = usePageTitle();
  const focusTrapRef = useFocusTrap();

  const toggleSearch: () => void = () => {
    setSearchOpen((prevState) => {
      return !prevState;
    });
  };
  const toggleDrawer: () => void = () => {
    setDrawerOpen((prevState) => {
      return !prevState;
    });
  };

  return (
    <>
      <Box component="header" className={styles.header}>
        <Container px={24}>
          <Flex py={16} justify="space-between" align="center">
            <Group>
              <Link
                href="/mypage"
                className={styles.headerLink}
                passHref
                aria-label="マイページへ遷移"
              >
                <AvatarIconMemo
                  avatar={userData?.profileImage}
                  background={userData?.profileBgImage}
                />
              </Link>
            </Group>
            <Group spacing={5} sx={{ width: "100%" }} position="center">
              {searchOpen ? (
                <TextInput
                  ref={focusTrapRef}
                  styles={() => {
                    return {
                      input: {
                        border: "none",
                        fontSize: "1.6rem",
                        height: "20px",
                        minHeight: "20px",
                      },
                      root: { width: "90%" },
                    };
                  }}
                />
              ) : (
                <h1 className={styles.pageTitle}>{pageTitle}</h1>
              )}
            </Group>
            <Space w={10} />
            <NotificationBadgeCount />
            <Space w={10} />
            <Group spacing={5}>
              {pageTitle === "フムフム" ? (
                <UnstyledButton onClick={toggleSearch} aria-label="検索">
                  {searchOpen ? <MdCancel size={24} /> : <MdSearch size={24} />}
                </UnstyledButton>
              ) : (
                <Burger
                  opened={drawerOpen}
                  onClick={toggleDrawer}
                  aria-label="ドロワーメニューを開く"
                />
              )}
            </Group>
          </Flex>
        </Container>
      </Box>
      <DrawerMenuMemo
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        toggleDrawer={toggleDrawer}
      />
    </>
  );
};
